import { IInitAction } from './init'
import { FormObjectType } from './pack'
import { IDateRange } from './date'

// Action types
export enum types {
  SEARCH_PACKS__STARTED = 'SEARCH_PACKS__STARTED',
  SEARCH_PACKS__SUCCESS = 'SEARCH_PACKS__SUCCESS',
  SEARCH_PACKS__FAILURE = 'SEARCH_PACKS__FAILURE',
  UPDATE_SKIP_QUERY = 'UPDATE_SKIP_QUERY',
  RESET_SEARCH = 'RESET_SEARCH',
}

export interface ISearchPacksAction {
  type: types.SEARCH_PACKS__STARTED
  query: IQuery
}

export interface ISearchPacksSuccessAction {
  type: types.SEARCH_PACKS__SUCCESS
  items: any[]
  totalCount: number
}

export interface IFailureAction {
  type: types.SEARCH_PACKS__FAILURE
  message: string
}

export interface IUpdateSkipQuery {
  type: types.UPDATE_SKIP_QUERY
  skip: number
}

export interface IResetSearchAction {
  type: types.RESET_SEARCH
}

export type SearchActionsType =
  | ISearchPacksAction
  | ISearchPacksSuccessAction
  | IFailureAction
  | IResetSearchAction
  | IUpdateSkipQuery
  | IInitAction

// Reducer types
export interface IQuery extends IDateRange {
  group?: string
  groupId?: string
  keywords?: string
  currentUser?: boolean
  modified?: {
    from?: string
    to?: string
  }
  expiring?: {
    from?: string
    to?: string
  }
  scheduled?: {
    from?: string
    to?: string
  }
  tags?: string[]
  topicCodes?: FormObjectType[]
  sluglines?: string
  take?: number
  orderBy?: string
  date?: FilterOptions
  includeMedia?: boolean
  advancedQuery?: boolean
  skip?: number
  graphicType?: string
  status?: string
}

export enum FilterOptions {
  modified = 'modified',
  expiryDate = 'expiryDate',
  nextScheduleDate = 'nextScheduleDate',
}

export enum SortOptions {
  modified = 'modified',
  expiryDate = 'expiryDate',
  nextScheduleDate = 'nextScheduleDate',
  relevance = 'relevance',
}

export type IDecoratedQuery = Omit<IQuery, 'topicCodes'> & {
  topicCodes?: string[]
}

export interface ISearch {
  isLoading: boolean
  items: any[]
  totalCount: number
  skip: number
  groupId?: string
}

export interface ISearchParams {
  keywords: string
  currentUser?: boolean
  orderBy?: string
}
